import { Partner } from '@returnmates/client-core/src/graphql/generated/api'

export const getMinPartnerSchedulerLimit = (selectedPackagePartners: Partner[]): number | null => {
  if (!selectedPackagePartners?.length) {
    return null
  }

  const schedulerLimits = selectedPackagePartners
    .map(partner => partner?.schedulerLimit)
    .filter(limit => typeof limit === 'number')

  if (!schedulerLimits.length) {
    return null
  }

  return Math.min(...schedulerLimits)
}

export const getPartnerNamesWithGreaterLimit = (
  selectedPackagePartners: Partner[],
  minPartnerSchedulerLimit: number | null,
): string => {
  if (!minPartnerSchedulerLimit || !selectedPackagePartners?.length) {
    return ''
  }

  return (
    selectedPackagePartners
      .filter(partner => partner.schedulerLimit > minPartnerSchedulerLimit)
      .map(partner => partner.name)
      .join(', ') || ''
  )
}
